<template>
  <v-div
    v-if="shouldShow"
    class="CompetingInterestsInformation"
    border-inverted-bottom-thick
    mt-3
    pb-3
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">
      Author’s competing interest statement
    </h2>
    <v-div
      v-if="hasCompetingInterests"
      class="CompetingInterestsDeclaration"
      pl-2
      font-smaller
      >{{ article.competingInterestsDeclaration }}</v-div
    >
    <v-div v-else pl-2 font-smaller
      >The author(s) have declared they have no conflict of interest with regard
      to this content</v-div
    >
  </v-div>
</template>

<script>
export default {
  name: "CompetingInterestsInformation",
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    shouldShow() {
      const { article = {} } = this;
      const { hasCompetingInterests } = article;

      return hasCompetingInterests !== null;
    },
    hasCompetingInterests() {
      return this.article.hasCompetingInterests;
    },
  },
};
</script>

<style scoped>
.CompetingInterestsDeclaration {
  white-space: pre-line;
}
</style>
